// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { format } from 'date-fns';

// const DashboardStockTable = () => {
//   const [tableData, setTableData] = useState([]);
//   const [selectedSeason, setSelectedSeason] = useState("");
//   const [selectedYear, setSelectedYear] = useState("");
//   const[selectedCommodity,setSelectedCommodity]=useState("");
  
// const user = JSON.parse(localStorage.getItem("user"));
// const navigate= useNavigate()
 
//    const fetchTableData = async () => {
//     try {
//       const res = await fetch(process.env.REACT_APP_BASE_URL + "dashboard/getStockChartReport", {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       });
//       const data =await res.json()
//       console.log(data)
//       // const data = json?.record || [];
//       console.log(data);
//   setTableData(Array.isArray(data) ? data : []);
//     } catch (err) {
//       console.error("Error fetching stats:", err);
//     }
//   };
//   useEffect(() => {
//       if (!user || !user.token) {
//         navigate("/");
//         return;
//       }
  
//      fetchTableData();
//     }, []);

//   const uniqueSeasons = [...new Set(tableData.map((item) => item.season))];
//   const uniqueYears = [...new Set(tableData.map((item) => item.year))];
//   const uniqueCommodity=[...new Set(tableData.map((item)=>item.commoditycode))]


//   return (
//     <motion.div
//       className="bg-white shadow p-6 rounded-lg mt-10"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5 }}
//     >
//       <h4 className="font-semibold text-lg mb-4">Stock Data</h4>

//       {/* Filters */}
//       <div className="flex flex-wrap gap-4 mb-4">
//         <div>
//           <label className="block mb-1 text-sm font-medium">Filter by Season:</label>
//           <select
//             value={selectedSeason}
//             onChange={(e) => setSelectedSeason(e.target.value)}
//             className="border border-gray-300 rounded px-2 py-1"
//           >
//             <option value="">All</option>
//             {uniqueSeasons.map((season, index) => (
//               <option key={index} value={season}>
//                 {season}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label className="block mb-1 text-sm font-medium">Filter by Commodity:</label>
//           <select
//             value={selectedCommodity}
//             onChange={(e) => setSelectedCommodity(e.target.value)}
//             className="border border-gray-300 rounded px-2 py-1"
//           >
//             <option value="">All</option>
//             {uniqueCommodity.map((comodity, index) => (
//               <option key={index} value={comodity}>
//                 {comodity}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label className="block mb-1 text-sm font-medium">Filter by Year:</label>
//           <select
//             value={selectedYear}
//             onChange={(e) => setSelectedYear(e.target.value)}
//             className="border border-gray-300 rounded px-2 py-1"
//           >
//             <option value="">All</option>
//             {uniqueYears.map((year, index) => (
//               <option key={index} value={year}>
//                 {year}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full border border-gray-200">
//           <thead className="bg-gray-100 text-gray-700 text-left">
//             <tr>
//               <th className="py-2 px-4 border-b">Vendor</th>
//               <th className="py-2 px-4 border-b">State</th>
//               <th className="py-2 px-4 border-b">Commodity</th>
//               <th className="py-2 px-4 border-b">Scheme</th>
//               <th className="py-2 px-4 border-b">Available Qtypss</th>
//               <th className="py-2 px-4 border-b">Available Qtypsf</th>
//               <th className="py-2 px-4 border-b">Age of Stock PSS</th>
//               <th className="py-2 px-4 border-b">Age of Stock PSF</th>
//               <th className="py-2 px-4 border-b">Last Updated Date</th>
//               <th className="py-2 px-4 border-b">Season</th>
//               <th className="py-2 px-4 border-b">Year</th>
//               <th className="py-2 px-4 border-b">Date</th>
//             </tr>
//           </thead>
//           <tbody>
//             <AnimatePresence>
//               {tableData.length > 0 ? (
//                 tableData.map((item, index) => (
//                   <motion.tr
//                     key={item.vendor + index}
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -10 }}
//                     transition={{ duration: 0.2 }}
//                     className="text-gray-600"
//                   >
//                     <td className="py-2 px-4 border-b">{item.vendor.name}</td>
//                     <td className="py-2 px-4 border-b">{item.statename}</td>
//                     <td className="py-2 px-4 border-b">{item.commoditycode}</td>
//                     <td className="py-2 px-4 border-b">{item.scheme}</td>
//                     <td className="py-2 px-4 border-b">{item.availableqtypss}</td>
//                     <td className="py-2 px-4 border-b">{item.availableqtypsf}</td>
//                     <td className="py-2 px-4 border-b">{item.ageofstockpss}</td>
//                     <td className="py-2 px-4 border-b">{item.ageofstockpsf}</td>
//                     <td className="py-2 px-4 border-b">{format(new Date(item.lastupdateddate), 'd MMM, yyyy')}</td>
//                     <td className="py-2 px-4 border-b">{item.season}</td>
//                     <td className="py-2 px-4 border-b">{item.year}</td>
//                     <td className="py-2 px-4 border-b">{format(new Date(item.createdAt), 'd MMM, yyyy')}</td>
//                   </motion.tr>
//                 ))
//               ) : (
//                 <motion.tr
//                   key="no-data"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   exit={{ opacity: 0 }}
//                 >
//                   <td colSpan="5" className="py-4 px-4 text-center text-gray-500">
//                     Loading or no data found.
//                   </td>
//                 </motion.tr>
//               )}
//             </AnimatePresence>
//           </tbody>
//         </table>
//       </div>
//     </motion.div>
//   );
// };

// export default DashboardStockTable;

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const DashboardStockTable = () => {
 const [tableData, setTableData] = useState([]);

   const [commodities, setCommodities] = useState([]);
   const [seasons, setSeasons] = useState([]);
   const [years, setYears] = useState([]);
   const [states, setStates] = useState([]);
   const [vendors, setVendors] = useState([]);
 
   const [selectedCommodity, setSelectedCommodity] = useState("");
   const [selectedSeason, setSelectedSeason] = useState("");
   const [selectedYear, setSelectedYear] = useState("");
   const [selectedState, setSelectedState] = useState("");
   const [selectedVendor, setSelectedVendor] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 10; // You can adjust per your UI
 
   const user = JSON.parse(localStorage.getItem("user"));
   const navigate = useNavigate();
 
   const baseUrl = process.env.REACT_APP_BASE_URL;
 
   // Helper to build query string based on selected filters
   const buildQueryParams = () => {
     const params = new URLSearchParams();
     if (selectedCommodity) params.append("commodityCode", selectedCommodity);
     if (selectedState) params.append("state", selectedState);
     if (selectedVendor) params.append("vendorId", selectedVendor);
     if (selectedYear) params.append("year", selectedYear);
     if (selectedSeason) params.append("season", selectedSeason);
     return params.toString();
   };
 
   // Fetch filter option lists
   const fetchFilterOptions = async () => {
     try {
       const [commodityRes, seasonRes, yearRes, stateRes, vendorRes] = await Promise.all([
         fetch(baseUrl + "commodity", { headers: { Authorization: `Bearer ${user?.token}` } }),
         fetch(baseUrl + "common/seasons", { headers: { Authorization: `Bearer ${user?.token}` } }),
         fetch(baseUrl + "common/years", { headers: { Authorization: `Bearer ${user?.token}` } }),
       fetch(baseUrl + "common/states", { headers: { Authorization: `Bearer ${user?.token}` } }),
         fetch(baseUrl + "users/vendors", { headers: { Authorization: `Bearer ${user?.token}` } }),
       ]);
 
       const commodityData = await commodityRes.json();
       const seasonData = await seasonRes.json();
       const yearData = await yearRes.json();
       const stateData = await stateRes.json();
       console.log(stateData)
       const vendorData = await vendorRes.json();
 console.log(vendorData)
       setCommodities(Array.isArray(commodityData) ? commodityData : []);
      //  setSeasons(Array.isArray(seasonData) ? seasonData : []);
     setSeasons(Array.isArray(seasonData) ? seasonData.map(season => ({
  key: season.key,
  value: season.value.toLowerCase().charAt(0).toUpperCase() + season.value.toLowerCase().slice(1)
})) : []);
 setYears(Array.isArray(yearData) ? yearData : []);
       setStates(Array.isArray(stateData) ? stateData : []);
       
       setVendors(Array.
        isArray(vendorData) ? vendorData : []);
     } catch (err) {
       console.error("Error fetching filter options:", err);
     }
   };
   // Fetch table data based on filters
   const fetchTableData = async () => {
     try {
       const queryParams = buildQueryParams();
       console.log(queryParams)
       const url = baseUrl + "dashboard/getStockChartReport" + (queryParams ? `?${queryParams}` : "");
       const res = await fetch(url, {
         headers: {
           Authorization: `Bearer ${user?.token}`,
         },
       });
       const data = await res.json();
       console.log(data)
       setTableData(Array.isArray(data) ? data : []);
       
     } catch (err) {
       console.error("Error fetching table data:", err);
     }
   };
 
   // On mount, check auth and fetch filter options + table data
   useEffect(() => {
     if (!user || !user.token) {
       navigate("/");
       return;
     }
     fetchFilterOptions();
   }, []);
 
   // Refetch table data whenever any filter changes
   useEffect(() => {
     fetchTableData();
   }, [selectedCommodity, selectedSeason, selectedYear, selectedState, selectedVendor]);
   const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);
const totalPages = Math.ceil(tableData.length / itemsPerPage);

// Handlers
const handleNext = () => {
  setCurrentPage((prev) => Math.min(prev + 1, totalPages));
};

const handlePrevious = () => {
  setCurrentPage((prev) => Math.max(prev - 1, 1));
};

const handleExport = () => {
  const exportData = tableData.map(item => ({
    Vendor: item.vendor.name,
    State: item.statename,
    Commodity: item.commoditycode,
    Scheme: item.scheme,
    "Available Qty PSS": item.availableqtypss,
    "Available Qty PSF": item.availableqtypsf,
    "Age of Stock PSS": item.ageofstockpss,
    "Age of Stock PSF": item.ageofstockpsf,
    "Last Updated Date": item.lastupdateddate,
    Season: item.season,
    Year: item.year,
    Date: item.createdAt,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "stock_report.xlsx");
};
  return (
    <motion.div
      className="bg-white shadow p-6 rounded-lg mt-10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h4 className="font-semibold text-lg mb-4">Stock Data</h4>
<button
    onClick={handleExport}
    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
  >
    Export to Excel
  </button>
      
      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-4">
        {/* Commodity Filter */}
        <div>
          <label className="block mb-1 text-sm font-medium">Filter by Commodity:</label>
          <select
            value={selectedCommodity}
            onChange={(e) => setSelectedCommodity(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1"
          >
            <option value="">All</option>
            {commodities.map(({ commoditycode, commodityname }) => (
              <option key={commoditycode} value={commoditycode}>
                {commodityname}
              </option>
            ))}
          </select>
        </div>

        {/* State Filter */}
        <div>
          <label className="block mb-1 text-sm font-medium">Filter by State:</label>
          <select
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1"
          >
            <option value="">All</option>
            {states.map(({ code, name }) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </select>
        </div>

        {/* Vendor Filter */}
        <div>
          <label className="block mb-1 text-sm font-medium">Filter by Vendor:</label>
          <select
  value={selectedVendor}
  onChange={(e) => setSelectedVendor(e.target.value)}
  className="border border-gray-300 rounded px-2 py-1"
>
  <option value="">All</option>
  {vendors.map((vendor) => (
    <option key={vendor.id} value={vendor.id}>
      {vendor.name}
    </option>
  ))}
</select>

        </div>
  {/* Season Filter */}
        <div>
          <label className="block mb-1 text-sm font-medium">Filter by Season:</label>
          <select
            value={selectedSeason}
            onChange={(e) => setSelectedSeason(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1"
          >
            <option value="">All</option>
            {seasons.map(({ key, value }) => (
              <option key={key} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>

        {/* Year Filter */}
        <div>
          <label className="block mb-1 text-sm font-medium">Filter by Year:</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1"
          >
            <option value="">All</option>
            {years.map(({ year }) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100 text-gray-700 text-left">
            <tr>
              <th className="py-2 px-4 border-b">Vendor</th>
              <th className="py-2 px-4 border-b">State</th>
              <th className="py-2 px-4 border-b">Commodity</th>
              <th className="py-2 px-4 border-b">Scheme</th>
              <th className="py-2 px-4 border-b">Available Qtypss</th>
              <th className="py-2 px-4 border-b">Available Qtypsf</th>
              <th className="py-2 px-4 border-b">Age of Stock PSS</th>
              <th className="py-2 px-4 border-b">Age of Stock PSF</th>
              <th className="py-2 px-4 border-b">Last Updated Date</th>
              <th className="py-2 px-4 border-b">Season</th>
              <th className="py-2 px-4 border-b">Year</th>
              <th className="py-2 px-4 border-b">Date</th>
            </tr>
          </thead>
          <tbody>
            <AnimatePresence>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <motion.tr
                    key={item.vendor + index}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    className="text-gray-600"
                  >
                    <td className="py-2 px-4 border-b">{item.vendor.name}</td>
                    <td className="py-2 px-4 border-b">{item.statename}</td>
                    <td className="py-2 px-4 border-b">{item.commoditycode}</td>
                    <td className="py-2 px-4 border-b">{item.scheme}</td>
                    <td className="py-2 px-4 border-b">{item.availableqtypss}</td>
                    <td className="py-2 px-4 border-b">{item.availableqtypsf}</td>
                    <td className="py-2 px-4 border-b">{item.ageofstockpss}</td>
                    <td className="py-2 px-4 border-b">{item.ageofstockpsf}</td>
                    <td className="py-2 px-4 border-b">{format(new Date(item.lastupdateddate), 'd MMM, yyyy')}</td>
                    <td className="py-2 px-4 border-b">{item.season}</td>
                    <td className="py-2 px-4 border-b">{item.year}</td>
                    <td className="py-2 px-4 border-b">{format(new Date(item.createdAt), 'd MMM, yyyy')}</td>
                  </motion.tr>
                ))
              ) : (
                <motion.tr
                  key="no-data"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <td colSpan="5" className="py-4 px-4 text-center text-gray-500">
                    Loading or no data found.
                  </td>
                </motion.tr>
              )}
            </AnimatePresence>
          </tbody>
        </table>

        {totalPages > 1 && (
  <div className="flex justify-end items-center gap-4 mt-4">
    <button
      onClick={handlePrevious}
      disabled={currentPage === 1}
      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
    >
      Previous
    </button>
    <span className="text-sm text-gray-600">
      Page {currentPage} of {totalPages}
    </span>
    <button
      onClick={handleNext}
      disabled={currentPage === totalPages}
      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
    >
      Next
    </button>
  </div>
)}
      </div>
    </motion.div>
  );
};

export default DashboardStockTable;



